import { useEffect } from 'react';
export const DEFAULT_LANGUAGE = 'hu';
export const TMS_LANGUAGE_COOKIE_NAME = 'tms_display_language';
export const ACP_LANGUAGE_COOKIE_NAME = 'acp_display_language';
export function useHtmlLang(locale) {
    useEffect(() => {
        document.documentElement.lang = locale;
    }, [locale]);
}
